import { render, staticRenderFns } from "./article-list.vue?vue&type=template&id=f4fce626&scoped=true&"
import script from "./article-list.vue?vue&type=script&lang=js&"
export * from "./article-list.vue?vue&type=script&lang=js&"
import style0 from "./article-list.vue?vue&type=style&index=0&id=f4fce626&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fce626",
  null
  
)

export default component.exports